var script = {
  name: 'Shortcuts',
  props: {
    options: {
      type: Array,
      default: null
    }
  },
  methods: {
    handleOptionClick(option) {
      if (option.disabled) {
        return;
      }
      this.$emit('select', option);
    }
  }
};

export { script as default };
//# sourceMappingURL=shortcuts.vue2.js.map
